import { createContext, useContext, useEffect, useState } from "react";
import UserApi from "../../../api/UserApi";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    
    UserApi.list()
      .then((res) => {
        const fetchedData = res.data?.data || res.data?.users || res.data || [];
        
        if (Array.isArray(fetchedData)) {
          setUsers(fetchedData);
        }
      })
      .catch((err) => console.error("API ERROR: User List Fetch Failed", err));
  }, []);

  return (
    <UserContext.Provider value={{ users }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUsers = () => {
  const context = useContext(UserContext);
  if (!context) {
    console.error("useUsers must be used within a UserProvider");
  }
  return context;
};